import "core-js/modules/es6.string.starts-with";
import mapStore from '@/store/modules/map';

var getActiveRule = function getActiveRule(hash) {
  return function (location) {
    return location.hash.startsWith(hash);
  };
};

export var microApps = [{
  name: 'typhoonAnalysis',
  entry: process.env.NODE_ENV === 'production' ? '../typhoonAnalysis/' : '//localhost:8888',
  container: '#qiankunBox',
  activeRule: process.env.NODE_ENV === 'production' ? getActiveRule('#/typhoonAnalysis') : '#/typhoonAnalysis',
  // 不一定和上面的name一样
  props: {
    apiKey: '',
    mapStore: mapStore,
    globalStyle: {
      topbar: 98
    }
  } // qiankun支持共享store 可以在子项目修改

}];